import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

const FilterBarComparison: FC = () => {
  const { t } = useTranslation()
  return (
    <div className="mg-filters-bar__comparison">
      <div className="mg-filters-bar__comparison__icon">
        <span className="material-icons-outlined notranslate">arrow_forward</span>
      </div>
      <div className="mg-filters-bar__comparison__title">{t('filters-bar.compared-to')}</div>
    </div>
  )
}

export default memo(FilterBarComparison)
